var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup225(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 50,
    viewBox: "0 0 59 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2791 1.52997H8.23699C4.7541 1.52997 1.93066 4.3534 1.93066 7.83629V41.47C1.93066 44.9529 4.7541 47.7763 8.23699 47.7763H50.2791C53.762 47.7763 56.5854 44.9529 56.5854 41.47V7.83629C56.5854 4.3534 53.762 1.52997 50.2791 1.52997Z",
    stroke: "#9BA9B6",
    strokeWidth: 2.9967,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7682 18.3467C42.0901 18.3467 43.9724 16.4644 43.9724 14.1425C43.9724 11.8205 42.0901 9.93825 39.7682 9.93825C37.4463 9.93825 35.564 11.8205 35.564 14.1425C35.564 16.4644 37.4463 18.3467 39.7682 18.3467Z",
    stroke: "#9BA9B6",
    strokeWidth: 2.9967,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5644 35.136L23.6533 23.2473C22.8954 22.4895 21.8766 22.0498 20.8053 22.0181C19.7341 21.9863 18.6911 22.3649 17.8896 23.0765L1.93066 37.2657M25.0538 47.7762L41.2585 31.5716C41.9995 30.829 42.9915 30.3904 44.0394 30.3418C45.0874 30.2931 46.1157 30.6381 46.9223 31.3088L56.5854 39.3678",
    stroke: "#9BA9B6",
    strokeWidth: 2.9967,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup225);
export default __webpack_public_path__ + "static/media/Group 225.bb2fb228dfb4c15b719f85f9b991e714.svg";
export { ForwardRef as ReactComponent };